export const animateMap = {
  'cxgz': {
    'RMA22': true,
    'RMA144': true,
    'RMA268': true,
    'RMA6059': true,
    'RMA6060': true,
    'RMA6061': true,
    'RMA6042': true,
    'RMA6094': true,
    'RMA270': true,
    'RMA61': true,
    'RMA59': true,
    'RMA6046': true,
    'RMA6127': true,
  },
  cjlx: {
    'RMA135': true,
    'RMA6144': true,
    'RMA6100': true,
    'RMA5091': true,
    'RMA186': true,
    'RMA200': true,
    'RMA102': true,
    'RMA203': true,
    'RMA113': true,
    'RMA33': true,
    'RMA86': true,
    'RMA58': true,
    'RMA6038': true,
    'RMA6032': true,
    'RMA6121': true,
    'RMA6122': true,
  },
  jjdq: {
    'RMA105': true,
    'RMA6126': true,
    'RMA107': true,
    'RMA20': true,
    'RMA18': true,
    'RMA146': true,
    'RMA133': true,
    'RMA29': true,
    'RMA5126': true,
    'RMA164': true,
    'RMA88': true,
    'RMA19': true,
    'RMA5086': true,
    'RMA6083': true,
    'RMA81': true,
    'RMA60': true,
    'RMA167': true,
    'RMA68': true,
    'RMA77': true,
    'RMA32': true,
    'RMA149': true,
    'RMA6034': true,
    'RMA6035': true,
    'RMA56': true,
    'RMA260': true,
    'RMA166': true,
    'RMA2': true,
    'RMA6045': true,
  },
  wysb: {
    'RMA6001': true,
    'RMA228': true,
    'RMA10': true,
    'RMA11': true,
    'RMA50': true,
    'RMA13': true,
    'RMA141': true,
    'RMA142': true,
    'RMA5020': true,
    'RMA155': true,
    'RMA271': true,
    'RMA242': true,
  },
  aqsb: {
    'RMA6074': true,
    'RMA6018': true,
    'RMA6072': true,
    'RMA6071': true,
    'RMA100': true,
    'RMA6067': true,
    'RMA6021': true,
    'RMA6068': true,
  },
  tsjk: {
    'RMA220': true,
    'RMA223': true,
    'RMA224': true,
    'RMA6012': true,
    'RMA6013': true,
    'RMA6017': true,
    'RMA6051': true,
    'RMA6052': true,
    'RMA6053': true,
    'RMA6029': true,
    'RMA6030': true,
    'RMA6031': true
  },
  qtfw: {
    'HAC1':true,
    'HAC6050':true,
    'HAC6024':true,
    'HAC283':true,
    'HAC5033':true,
    'HAC26':true,
    'HAC327':true,
    'HAC15':true,
    'HAC41':true,
  },
  zyfw: {

    'HAC6132':true,
    'HAC6121':true,
    'HAC50':true,
    'HAC61':true,
    'HAC348':true,
    'HAC6137':true,
    'HAC61111':true,
    'HAC9991':true,
    'HAC9992':true,

  },
  cyfw: {
    'HAC157':true,
    'HAC265':true,
    'HAC9993':true,
    'HAC9994':true,
  },
  xcss: {
    'HAC9995':true,
    'HAC6059':true,
    'HAC33':true,
    'HAC101':true,
    'HAC76':true,
    'HAC9996':true,
    'HAC228':true,
    'HAC6097':true,
    'HAC345':true,
    'HAC9997':true,
    'HAC54':true,
    'HAC32':true,
    'HAC98':true,
    'HAC7':true,
  },
  hdjs: {
    'RST80': true,
    'RST101': true,
    'RST116': true,
    'RST63': true,
    'RST65': true,
    'RST149': true,
    'RST160': true,
    'RST86': true,
    'RST20': true,
    'RST105': true,
    'RST108': true,
    'RST112': true,
    'RST87': true,
    'RST120': true,
    'RST13': true,
    'RST137': true,
    'RST127': true,
    'RST34': true,
    'HAC237': true,
    'RST183': true,
    'RST79': true,
    'RST186': true,
    'RST172': true,
    'RST177': true,
  }
}
